import { ClientEnvironment, ClientEnvironmentName } from '../modules/core/types/environment';

export const environment: ClientEnvironment = {
	environmentName: ClientEnvironmentName.STAGING,
	apiUrl: 'https://api.staging.rea.ch',
	clientUrl: 'https://mobile.staging.rea.ch',
};
